import * as React from 'react';
import { Link } from 'react-router';
import styled, { withTheme } from 'styled-components';
import { rem, darken } from 'polished';
import { TextP } from '../../Defaults/Text';
import { FlexCol, FlexBetween } from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { TableTd, TableRow, DefaultTableTd } from '../General/Table';
import {
  getInvoiceDetailInfo,
  getOrderRowInfo,
  getRequestRowInfo,
} from '../../../utilities/selectors';
import { SvgIcon, IconType } from '../General/SvgIcon';
import { getRequestIcon, getRequestColor } from '../../../utilities';

export interface Props {
  request: any;
  theme: any;
}

function RequestRow({ request, theme }: Props) {
  const {
    id,
    date,
    status,
    statusReadable,
    requestNr,
    url,
    yourNr,
  } = getRequestRowInfo(request);
  const color = getRequestColor(status, theme);
  const icon = getRequestIcon(status);

  return (
    <StyledTableRow>
      <StyledTableTd>
        <LinkToRequest to={url}>
          <CellText>{requestNr}</CellText>
        </LinkToRequest>
      </StyledTableTd>
      <StyledTableTd>
        <CellText>{yourNr}</CellText>
      </StyledTableTd>
      <StyledTableTd>
        <CellText>{date}</CellText>
      </StyledTableTd>
      <StatusTd>
        <SvgIcon
          width={24}
          height={24}
          icon={icon}
          alt="Stav objednávky"
          title="Stav objednávky"
          marginRight={8}
          fill={color}
        />
        <StatusText color={color}>{statusReadable}</StatusText>
      </StatusTd>
    </StyledTableRow>
  );
}

const StyledTableTd = styled(TableTd)`
  padding: ${rem(16)} ${rem(24)};
  border-bottom: ${({ theme }) => theme.borders.primary};
`;

const StatusTd = styled(StyledTableTd)`
  display: flex;
  align-items: center;
`;

const StyledTableRow = styled(TableRow)`
  padding: ${rem(24)} 0;
  border-top: ${({ theme }) => theme.borders.primary};

  &:last-child {
    border-bottom: ${({ theme }) => theme.borders.primary};
  }
`;

const LinkToRequest = styled(Link)`
  text-decoration: none;
  color: ${({ theme }) => theme.colors.textPrimary};

  &:hover {
    text-decoration: underline;
  }
`;

const CellText = styled(TextP)`
  font-size: ${rem(14)};
  line-height: ${rem(22)};
  color: ${({ theme }) => theme.colors.textPrimary};
  text-align: left;
  font-family: ${({ theme }) => theme.font.secondary};
  font-weight: 400;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const StatusText = styled(CellText)<{ color?: string }>`
  color: ${({ theme, color }) => (color ? color : theme.colors.textPrimary)};
`;

const WithThemeRow: any = withTheme(RequestRow);
export { WithThemeRow as RequestRow };
